import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "./index.css";
import { jsx, jsxs } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import classNames from 'classnames';
var range = function range(start, end) {
  var length = end - start + 1;
  return Array.from({
    length: length
  }, function (_, idx) {
    return idx + start;
  });
};
var calculateItems = function calculateItems(_ref) {
  var totalCount = _ref.totalCount,
    pageSize = _ref.pageSize,
    currentPage = _ref.currentPage,
    ellipsis = _ref.ellipsis,
    siblingCount = _ref.siblingCount,
    visibleItemsNumber = _ref.visibleItemsNumber;
  var totalPageCount = Math.ceil(totalCount / pageSize);
  var firstPageIndex = 1;
  var lastPageIndex = totalPageCount;
  var totalPaginationPositions = 2 * siblingCount + visibleItemsNumber;
  if (totalPaginationPositions >= totalPageCount) return range(firstPageIndex, lastPageIndex);
  var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
  var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
  var shouldShowLeftEllipsis = leftSiblingIndex > 2;
  var shouldShowRightEllipsis = rightSiblingIndex < totalPageCount - 2;
  if (shouldShowLeftEllipsis && shouldShowRightEllipsis) {
    return [firstPageIndex, ellipsis].concat(_toConsumableArray(range(leftSiblingIndex, rightSiblingIndex)), [ellipsis, lastPageIndex]);
  }
  if (!shouldShowLeftEllipsis) return [].concat(_toConsumableArray(range(firstPageIndex, siblingCount + currentPage)), [ellipsis, totalPageCount]);
  if (!shouldShowRightEllipsis) {
    var pagesToEnd = totalPageCount - currentPage;
    return [firstPageIndex, ellipsis].concat(_toConsumableArray(range(totalPageCount - siblingCount - pagesToEnd, lastPageIndex)));
  }
  return [];
};
var Pagination = function Pagination(_ref2) {
  var onPageChange = _ref2.onPageChange,
    totalCount = _ref2.totalCount,
    currentPage = _ref2.currentPage,
    pageSize = _ref2.pageSize,
    _ref2$previousText = _ref2.previousText,
    previousText = _ref2$previousText === void 0 ? '<' : _ref2$previousText,
    _ref2$nextText = _ref2.nextText,
    nextText = _ref2$nextText === void 0 ? '>' : _ref2$nextText,
    _ref2$siblingCount = _ref2.siblingCount,
    siblingCount = _ref2$siblingCount === void 0 ? 1 : _ref2$siblingCount,
    _ref2$ariaLabels = _ref2.ariaLabels,
    ariaLabels = _ref2$ariaLabels === void 0 ? {
      paginationList: 'pagination list',
      page: 'page',
      previousPage: 'previous page',
      nextPage: 'next page'
    } : _ref2$ariaLabels,
    className = _ref2.className;
  var ellipsis = '…';
  var visibleItemsNumber = 3;
  var paginationRange = calculateItems({
    currentPage: currentPage,
    totalCount: totalCount,
    siblingCount: siblingCount,
    pageSize: pageSize,
    ellipsis: ellipsis,
    visibleItemsNumber: visibleItemsNumber
  });
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }
  var onNext = function onNext() {
    return onPageChange(currentPage + 1);
  };
  var onPrevious = function onPrevious() {
    return onPageChange(currentPage - 1);
  };
  var lastPage = paginationRange[paginationRange.length - 1];
  return jsx("nav", Object.assign({
    className: "cds-pagination",
    "aria-label": ariaLabels.paginationList
  }, {
    children: jsxs("ul", Object.assign({
      className: classNames('cds-pagination__list', className)
    }, {
      children: [jsx("li", Object.assign({
        className: classNames('cds-pagination__item cds-pagination__item--previous', {
          'cds-pagination__item--disabled': currentPage === 1
        })
      }, {
        children: jsx(Button, Object.assign({
          variant: "nav",
          className: "cds-pagination__item--btn-nav",
          onClick: onPrevious,
          "aria-label": ariaLabels.previousPage,
          disabled: currentPage === 1
        }, {
          children: previousText
        }))
      })), paginationRange.map(function (page, index) {
        return jsx("li", Object.assign({
          className: classNames('cds-pagination__item', {
            'cds-pagination__item--selected': page === currentPage,
            'cds-pagination__item--ellipsis': page === ellipsis
          })
        }, {
          children: page === ellipsis ? page : jsx(Button, Object.assign({
            variant: "nav",
            className: "cds-pagination__item--btn-nav",
            onClick: function onClick() {
              return onPageChange(page);
            },
            disabled: page === currentPage,
            "aria-label": "".concat(ariaLabels.page, " ").concat(page)
          }, {
            children: page
          }))
        }), index);
      }), jsx("li", Object.assign({
        className: classNames('cds-pagination__item cds-pagination__item--next', {
          'cds-pagination__item--disabled': currentPage >= lastPage
        })
      }, {
        children: jsx(Button, Object.assign({
          variant: "nav",
          className: "cds-pagination__item--btn-nav",
          onClick: onNext,
          "aria-label": ariaLabels.nextPage,
          disabled: currentPage >= lastPage
        }, {
          children: nextText
        }))
      }))]
    }))
  }));
};
export { Pagination };